import React, {
  useEffect,
  useState,
} from 'react';
import {
  Grid,
  Typography,
} from '@material-ui/core';
import { useQuery } from '@apollo/react-hooks';
import { generateLabel, transformLockCode } from '../../utils/helpers';
import { GET_LOCK_CODE } from '../../graphql/queries/CodeGenerator';
import CustomButton from '../CustomButton';
import Spinner from '../CustomSpinner';

type Props = {
  access_notes?: string;
  serialNumber?: string;
  setCode: (code:string) => void
  hasADC?: boolean;
  handleDisarmAlarm?: () => void
};

const LockCode: React.FC<Props> = ({ serialNumber, setCode, access_notes, hasADC, handleDisarmAlarm}) => {
  const [timeStamp, setTimestamp] = useState<number>(new Date().getMinutes());

  // eslint-disable-next-line no-param-reassign
  if (serialNumber === undefined || serialNumber === '') { serialNumber = '0'; }
  useEffect(() => {
    const interval = setInterval(() => {
      const date = new Date();
      setTimestamp(date.getMinutes());
    }, 30000);
    return () => clearInterval(interval);
  });

  const { data, refetch, loading } = useQuery<{ code: string }>(
    GET_LOCK_CODE,
    {
      variables: {
        sn: serialNumber,
        minutes: timeStamp,
      },
      fetchPolicy: 'network-only',
    },
  );

  useEffect(()=> {
    if(data?.code){
      setCode(transformLockCode(data?.code))
    }
  }, [data, setCode])

  const handleRetryCode = () => {
    refetch({
      sn: serialNumber,
      minutes: timeStamp,
    });
  };

  const responseCode = transformLockCode(data?.code);
  return (
    <>
      {responseCode.length > 4
        ? (
          <>
            <Typography variant="body1" align="left">
              <span style={{ fontWeight: 'bold' }}>
                {generateLabel('unlock_code')}
                :
                {' '}
              </span>
            </Typography>
            <Typography variant="body1" align="left">
              {' '}
              <span style={{
                fontWeight: 'bold', fontSize: '24px', letterSpacing: '14px',
              }}
              >
                {loading ? <Spinner size={20} /> : responseCode}
              </span>
            </Typography>
            <Typography variant="body1" align="left" style={{marginTop: '20px'}}>
              {' '}
              <span style={{
                fontWeight: 'bold', fontSize: '24px', letterSpacing: '2px'
              }}
              >
                {access_notes}
              </span>
            </Typography>
          </>
        )
        : (
          <>
            <Typography variant="body1" align="left">
              <span style={{ fontWeight: 'bold' }}>
                {generateLabel('unlock_code')}
          :
                {' '}
              </span>
              {' '}
              <span style={{
                fontWeight: 'bold', fontSize: '24px', letterSpacing: '14px', marginLeft: '5px',
              }}
              >
                {loading ? <Spinner size={20} /> : responseCode}
              </span>
            </Typography>
          </>
        )
      }
      <Grid container xs={12} spacing={1}>
        <Grid item>
          <CustomButton variant="orange" onClick={handleRetryCode}>
            Retry
          </CustomButton>                    
        </Grid>
        
        {hasADC && (
          <Grid item>
            <CustomButton variant="orange" onClick={handleDisarmAlarm}>
              Disarm Alarm
            </CustomButton>
          </Grid>
        )}
      </Grid>
    </>
  );
};

export default LockCode;
